import { useBusinessQuery } from '../../../api/businesses';
import { useCustomerQuery } from '../../../api/customers';
import { HomePage } from './HomePage';
import { VerificationPage } from './VerificationPage';

export function HomeGuard() {
  const customerQuery = useCustomerQuery();
  const businessQuery = useBusinessQuery();
  if (customerQuery.isPending || businessQuery.isPending) {
    return null;
  }

  if (
    businessQuery.data?.business.state !== 'VERIFIED' ||
    businessQuery.data?.profile.state !== 'ACTIVE'
  ) {
    return <VerificationPage />;
  }

  return <HomePage />;
}
